import {css} from "@emotion/react";

export const signup__redirect_to_login__link = css({
    fontSize: '0.75em',
    marginBlock: 'unset',
    marginBottom: '1.5em',
});
